import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private InquirySupplierRequests Types */
import {
  Settings,
  InquirySupplierRequests,
  _InquirySupplierRequests
} from '../namespace-helper'

import _ from 'lodash'

const selectedInquirySupplierRequestTemplate = {
  id: 0,
  inquiries_id: 0,
  suppliers_id: 0,
  inquiries_supplier_requests_status_id: 0,
  supplier: {}
}

const selectedRequestMessage = {
  message_content: '',
  attachments: [
    { documents_id: 0 },
    { documents_id: 0 }
  ]
}

export default {
  namespaced: true,
  state: {
    inquirySupplierRequests: [],
    inquirySupplierRequestDocumentViewTokens: [],
    selectedInquirySupplierRequest: _.cloneDeep(selectedInquirySupplierRequestTemplate),
    message: _.cloneDeep(selectedRequestMessage),
    openDialog: false,
    messageChanUUID: null
  },
  mutations: {
    [_InquirySupplierRequests.mutations.setInquirySupplierRequests] (state, payload) {
      state.inquirySupplierRequests = payload
    },
    [_InquirySupplierRequests.mutations.setInquirySupplierRequestsDocumentViewTokens] (state, payload) {
      state.inquirySupplierRequestDocumentViewTokens = payload
    },
    [_InquirySupplierRequests.mutations.setSelectedInquirySupplierRequest] (state, payload) {
      if (payload !== null) {
        state.selectedInquirySupplierRequest = payload
      } else {
        state.selectedInquirySupplierRequest = _.cloneDeep(selectedInquirySupplierRequestTemplate)
      }
    },
    [_InquirySupplierRequests.mutations.setOpenCloseInquirySupplierRequestMessageDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_InquirySupplierRequests.mutations.setInquirySupplierRequestsMessage] (state, payload) {
      if (payload !== null) {
        state.message = payload
      } else {
        state.message = _.cloneDeep(selectedRequestMessage)
      }
    },
    [_InquirySupplierRequests.mutations.setMessageChanUUID] (state, payload) {
      state.messageChanUUID = payload
    }
  },
  actions: {
    [_InquirySupplierRequests.actions.loadInquirySupplierRequests] (context, payload) {
      console.log('loadInquirySupplierRequests: ' + JSON.stringify(payload))
      console.log('loadInquirySupplierRequests: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/inquirySupplierRequests/inquiry/' + payload.id + '?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_InquirySupplierRequests.mutations.setInquirySupplierRequests, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_InquirySupplierRequests.actions.loadInquirySupplierRequestsMessage] (context, payload) {
      console.log('loadInquirySupplierRequestsMessage: ' + JSON.stringify(payload))
      console.log('loadInquirySupplierRequestsMessage: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/messages/' + payload

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_InquirySupplierRequests.mutations.setInquirySupplierRequestsMessage, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_InquirySupplierRequests.actions.createInquirySupplierRequestsDocumentViewTokens] (context, payload) {
      console.log('createInquirySupplierRequestsDocumentViewTokens: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/inquirySupplierRequests/documentToken/' + payload.id + '?filename=' + payload.filename

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_InquirySupplierRequests.mutations.setInquirySupplierRequestsDocumentViewTokens, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_InquirySupplierRequests.actions.sendInquirySupplierRequests] (context, payload) {
      console.log('sendInquirySupplierRequests: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/inquirySupplierRequests/sendRequest/' + payload.id

      payload.messageChanUUID = store.getters[InquirySupplierRequests.getters.getMessageChanUUID]

      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        return axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_InquirySupplierRequests.actions.setSelectedInquirySupplierRequest] ({ commit }, payload) {
      commit(_InquirySupplierRequests.mutations.setSelectedInquirySupplierRequest, payload)
    },
    [_InquirySupplierRequests.actions.openCloseInquirySupplierRequestMessageDialog] ({ commit }) {
      commit(_InquirySupplierRequests.mutations.setOpenCloseInquirySupplierRequestMessageDialogState)
    },
    [_InquirySupplierRequests.actions.setInquirySupplierRequestsMessage] ({ commit }, payload) {
      commit(_InquirySupplierRequests.mutations.setInquirySupplierRequestsMessage, payload)
    },
    [_InquirySupplierRequests.actions.setMessageChanUUID] ({ commit }, payload) {
      commit(_InquirySupplierRequests.mutations.setMessageChanUUID, payload)
    },
    [_InquirySupplierRequests.actions.resetState] ({ commit }, payload) {
      commit(_InquirySupplierRequests.mutations.setInquirySupplierRequests, [])
      commit(_InquirySupplierRequests.mutations.setSelectedInquirySupplierRequest, null)
      commit(_InquirySupplierRequests.mutations.setInquirySupplierRequestsMessage, null)
      // commit(_InquirySupplierRequests.mutations.setMessageChanUUID, null)
    }
  },
  getters: {
    [_InquirySupplierRequests.getters.inquirySupplierRequests] (state) {
      return state.inquirySupplierRequests
    },
    [_InquirySupplierRequests.getters.getInquirySupplierRequestsDocumentViewTokens] (state) {
      return state.inquirySupplierRequestDocumentViewTokens
    },
    [_InquirySupplierRequests.getters.getSelectedInquirySupplierRequest] (state) {
      return state.selectedInquirySupplierRequest
    },
    [_InquirySupplierRequests.getters.getInquirySupplierRequestsMessage] (state) {
      return state.message
    },
    [_InquirySupplierRequests.getters.getMessageChanUUID] (state) {
      return state.messageChanUUID
    },
    [_InquirySupplierRequests.getters.getOpenInquirySupplierRequestMessageDialogState] (state) {
      return state.openDialog
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/InquirySupplierRequests/inquirySupplierRequests.js